import { APP_ID } from '../request/params';
import { getClientStore } from '../state';
import { ICommonParams, IEventData } from '../types';
import { uaInfo } from '../utils/system';
// event unique id
export const generateEventUUID = (): string => {
  return `web_${new Date().getTime()}_${Math.random()}`;
};

export const getTrackUserInfo = () => {
  const authData = getClientStore().getState().user.authData;

  return {
    user_id: String(authData?.userId || 0),
    uuid: authData?.uuid || generateUUID(),
    is_login: authData ? (authData?.isAnonymous ? 0 : 1) : 0,
    device_id: authData ? authData?.deviceId : 0,
  };
};

export const generateUUID = () => {
  // Public Domain/MIT
  let d = new Date().getTime(); //Timestamp
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const getTrackCommonData = () => {
  return getClientStore().getState().global.trackCommonData;
};

export const getCommonParams = (): Omit<ICommonParams, 'page' | 'event_name'> => {
  const { user_id, uuid, is_login, device_id } = getTrackUserInfo();
  const os = 'browser';
  const ua = uaInfo.userAgent;
  const app_id = APP_ID;
  const event_time = new Date().getTime();
  const platform = uaInfo.isH5 ? 'mobile' : 'pc';
  const commonData = getTrackCommonData() || {};
  //  优先使用客户端ip、ip_region 作为上报数据
  //   const ip_region = commonData?.client_ip_region || commonData?.server_ip_region || '';
  const ip = commonData.ip;
  const parent_page = typeof window === 'undefined' ? '' : document.referrer;

  return {
    user_id,
    uuid,
    os,
    ua,
    app_id,
    event_time,
    platform,
    is_login,
    ip,
    parent_page,
    device_id,
    log_source: 'ugc_web',
  };
};

export interface ITrack {
  asyncEventQueue: IEventData[];
  authReadyEventQueue: IWaitAuthDataEvent[];

  reportGap: number;
  reportTimer: NodeJS.Timeout | null;

  lastReportTime: number;

  send(
    event_name: string,
    page: string,
    event_data?: Record<string, unknown>,
    common_params?: Record<string, unknown>
  ): Promise<void>;

  collect(
    event_name: string,
    page: string,
    event_data?: Record<string, unknown>,
    common_params?: Record<string, unknown>
  ): void;

  report(payload?: IEventData): Promise<void>;
}

export interface IWaitAuthDataEvent {
  event_name: string;
  page: string;
  event_data: Record<string, unknown>;
  common_params: Record<string, unknown>;
}
